import ResetPasswordPIVariant from './ResetPasswordPIVariant.component';
export default ResetPasswordPIVariant;